import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "no_wrapper" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "text fs14" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'cl-no-data',
    props: {
        imgType: { default: 'default' },
        text: { default: '暂无数据' },
        width: { default: '100%' },
        height: { default: '100%' },
        background: { default: 'transparent' },
        showImg: { type: Boolean, default: true }
    },
    setup(__props) {
        /**
         * ComponentName: 暂无数据
         * 组件说明：
         * showImg 是否展示图片，默认展示
         * eg:
         *  <cl-no-data img-type="file"></cl-no-data>
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "no_container",
                style: _normalizeStyle({ height: __props.height, width: __props.width, background: __props.background })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.showImg)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require(`./no-data-${__props.imgType}.svg`)
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.text), 1)
                ])
            ], 4));
        };
    }
});
